import { useEffect, useRef, useState } from 'react';

type Props = {
  setValue: (value: string) => void;
  enabled?: boolean;
  value: string;
  ms?: number;
};

export const useTypeWriter = ({ value, setValue, enabled = true, ms = 25 }: Props) => {
  const [isTyping, setIsTyping] = useState(false);

  const enabledRef = useRef(enabled);
  const setValueRef = useRef(setValue);

  useEffect(() => {
    if (enabledRef.current) {
      setIsTyping(true);
      let i = 0;
      const interval = setInterval(() => {
        setValueRef.current(value.slice(0, i + 1));
        i += 1;
        if (i >= value.length) {
          setIsTyping(false);
          clearInterval(interval);
        }
      }, ms);
      return () => clearInterval(interval);
    }
  }, [value, ms]);

  return { isTyping };
};
